import { TEXT_STRING } from '../../constants';
import Icon from '../Icon';

type LineAddFriendModalProps = {
  isOpen: boolean;
  lineAddFriendUrl: string;
  messageText?: string;
  buttonText?: string;
};

function LineAddFriendModal({
  isOpen,
  lineAddFriendUrl,
  messageText = TEXT_STRING.COMMON.LINE_ACCOUNT_CHANGE_MESSAGE,
  buttonText = TEXT_STRING.COMMON.LINE_ADD_FRIEND_BUTTON,
}: LineAddFriendModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-sm w-full p-6 flex flex-col items-center gap-5">
        <p className="text-base text-center text-gray-800">
          {messageText}
        </p>
        <a
          href={lineAddFriendUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full py-3 px-4 rounded-lg text-white font-medium text-center transition-opacity hover:opacity-90"
          style={{ backgroundColor: '#06C755' }}
        >
          <Icon icon="line" color="white" />
          <span>{buttonText}</span>
        </a>
      </div>
    </div>
  );
}

export default LineAddFriendModal;
